import React, { useState } from 'react';

import { 
  Campaign, 
} from "@dndModels";

import SendToCharacters from '@dndComponents/campaign/SendToCharacters';
import MailButton from '@components/input/buttons/icon_buttons/MailButton';
import ModalOrDrawer from '@components/display/ModalOrDrawer';

interface Props {
  campaign: Campaign;
  fab?: boolean;
}

export default function CampaignMailButton({
  campaign,
  fab = false
}: Props) {
  const [open, setOpen] = useState(false);

  const renderExtras = () => {
    const wide_mode = window.innerWidth > 800;
    return (
      <ModalOrDrawer 
        open={ open } 
        width={ wide_mode ? 800 : undefined }
        full_page
        onClose={() => setOpen(false) }>
        <SendToCharacters
          campaign={campaign}
        />
      </ModalOrDrawer>
    );
  }

  return (
    <>
      <MailButton
        fab={fab}
        onClick={() => { setOpen(true); }}
      />
      { renderExtras() }
    </>
  ); 
}

